<template>
  <!-- ******** Inicio Lista de Contatos ******** -->
  <div>
    <WelcomeCard
      v-if="!$store.getters.isSeller"
      title="Aviso"
      style=""
    >
      <template #default>
        <h5 class="caption my-1">
          Você está utilizando um perfil de gerente. Sua agenda permanecerá
          vazia.
        </h5>
      </template>
    </WelcomeCard>
    <v-container class="pa-4">
      <TitleChip title="Agenda" />
      <v-layout class="d-flex column">
        <v-flex class="animated fadeIn delay-1s">
          <v-autocomplete
            v-model="selected"
            class="px-2 mt-0 search-autocomplete"
            :search-input.sync="search"
            no-filter
            :items="items"
            :loading="searching"
            color="primary"
            hide-selected
            append-icon=""
            hide-no-data
            item-text="description"
            placeholder="Buscar"
            prepend-icon="$vuetify.icons.searchIcon"
            return-object
            @change="$router.push(`/contato/${selected._id}`)"
          >
            <template #item="data">
              <v-list-tile-avatar class="pl-2">
                <div
                  v-lazy-container="{
                    error: 'https://s3.amazonaws.com/konselior/blankwhats.jpg',
                    loading: 'https://s3.amazonaws.com/konselior/blankwhats.jpg',
                  }"
                >
                  <img
                    v-if="data.item.celular && data.item.celular.whatsapp"
                    class="avatarImg"
                    :data-src="data.item.celular.whatsapp.picture"
                  >
                  <img
                    v-if="!data.item.celular || !data.item.celular.whatsapp"
                    class="avatarImg"
                    :data-src="'https://s3.amazonaws.com/konselior/blankwhats.jpg'"
                  >
                </div>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title
                  class="alignSelect"
                  v-html="
                    `${data.item.nome ? data.item.nome : ''} ${
                      data.item.sobrenome ? data.item.sobrenome : ''
                    }`
                  "
                />
                <v-list-tile-sub-title
                  v-if="data.item.celular"
                  v-html="
                    `(${
                      data.item.celular.phoneArea
                        ? data.item.celular.phoneArea
                        : '00'
                    }) ${data.item.celular.phone ? data.item.celular.phone : ''}`
                  "
                />
              </v-list-tile-content>
            </template>
          </v-autocomplete>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex
          xs6
          class="animated fadeIn delay-1s"
        />
      </v-layout>

      <!-- ******** Inicio Content Panel ******** -->
      <v-layout
        v-if="!isLoading"
        row
        wrap
        class="animated fadeIn delay-1s marginToBottom"
      >
        <v-expansion-panel>
          <v-expansion-panel-content
            v-for="tipo in tipos"
            :key="tipo.menu"
            class="mb-2"
          >
            <template #actions>
              <div />
            </template>
            <template #header>
              <v-layout
                row
                wrap
              >
                <v-flex xs12>
                  <v-card flat>
                    <h5 class="text-xs-left ml-2 pb-2 menu-title">
                      <v-icon
                        small
                        :color="tipo.color"
                        class="mr-2"
                      >
                        {{ tipo.icon }}
                      </v-icon>
                      {{ tipo.menu }}
                      <span class="legenda">({{ tipo.count() }})</span>
                    </h5>
                  </v-card>
                </v-flex>
              </v-layout>
            </template>

            <v-card>
              <v-card-text class="customCardMenu">
                <v-list subheader>
                  <v-list-tile
                    v-if="tipo.add"
                    avatar
                    class="mb-2"
                    to="/cadastrarlead"
                  >
                    <v-list-tile-avatar
                      :class="`mr-2 pl-2 ml-1 CREATE`"
                      color="#ECF6AA"
                    >
                      <!-- <div v-lazy-container="{ error: 'https://s3.amazonaws.com/konselior/blankwhats.jpg', loading: 'https://s3.amazonaws.com/konselior/blankwhats.jpg' }">
                <img class="avatarImg" :data-src="'https://s3.amazonaws.com/konselior/blankwhats.jpg'">
              </div> -->
                      <strong> + </strong>
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                      <v-list-tile-title>
                        <span
                          class="textoLead"
                        >Criar Potencial Cliente</span>
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
                <ListaContatos
                  :id="tipo.menu"
                  :getter="tipo.getter"
                  :setter="tipo.setter"
                  :situacao="tipo.situacao"
                />
              <!-- Chama ListaContatos.vue -->
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      <!-- ******** Fim Content Panel ******** -->
      </v-layout>
      <Loader v-else />
    </v-container>
    <div />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { FindPeople, SituationCount } from '@/apollo';
import { APIService } from '@/resources/campanha.js';
import Loader from '../components/Loader.vue';

const api = new APIService();
export default {
  components: {
    Loader,
  },
  data() {
    return {
      matches: [],
      selected: null,
      search: '',
      searching: false,
      lastLetter: null,
      customer: null,
      store: null,
      loading: true,
      isLoading: false,
      situationCount: {},
      tipos: [
        {
          menu: 'Melhores Clientes',
          icon: '$vuetify.icons.heartEyesIcon',
          color: 'primary',
          getter: 'getMelhoresClientes',
          setter: 'SET_AGENDA_BEST',
          situacao: 'melhores',
          count: () => this.situationCount.melhores || 0,
        },
        {
          menu: 'Primeira Compra',
          icon: '$vuetify.icons.sparklesIcon',
          color: 'primary',
          getter: 'getPrimeiraCompra',
          setter: 'SET_AGENDA_PRIMEIRA',
          situacao: 'primeiraCompra',
          count: () => this.situationCount.primeiraCompra || 0,
        },
        {
          menu: 'Clientes Ativos',
          icon: '$vuetify.icons.gearCheckIcon',
          color: 'primary',
          getter: 'getClientesAtivos',
          setter: 'SET_AGENDA_ATIVOS',
          situacao: 'ativo',
          count: () => this.situationCount.ativo || 0,
        },
        {
          menu: 'Clientes de Risco',
          icon: '$vuetify.icons.alertIcon',
          color: 'primary',
          getter: 'getClientesRisco',
          setter: 'SET_AGENDA_RISCO',
          situacao: 'risco',
          count: () => this.situationCount.risco || 0,
        },
        {
          menu: 'Clientes Inativos',
          icon: '$vuetify.icons.exclamationCircleIcon',
          color: 'primary',
          getter: 'getClientesInativos',
          setter: 'SET_AGENDA_INATIVOS',
          situacao: 'inativo',
          count: () => this.situationCount.inativo || 0,
        },
        {
          menu: 'Clientes Perdidos',
          icon: '$vuetify.icons.userIcon',
          color: 'primary',
          getter: 'getClientesPerdidos',
          setter: 'SET_AGENDA_PERDIDOS',
          situacao: 'perdido',
          count: () => this.situationCount.perdido || 0,
        },
        {
          menu: 'Potenciais Clientes',
          icon: '$vuetify.icons.moneyBagIcon',
          color: 'primary',
          getter: 'getLeads',
          setter: 'SET_AGENDA_LEAD',
          situacao: 'lead',
          add: true,
          count: () => this.situationCount.lead || 0,
        },
      ],
    };
  },
  computed: {
    items() {
      if (!this.matches) return;
      const people = this.matches.map((entry) => {
        const description = `${entry.nome ? entry.nome : ''} ${
          entry.sobrenome ? entry.sobrenome : ''
        }`;
        return { ...entry, description };
      });
      return people;
    },
    ...mapState(['agenda']),
    ...mapGetters(['getStore']),
  },
  watch: {
    async getStore() {
      await this.getSchedule();
    },
    async search() {
      if (!this.search || this.search.length < 3) {
        this.searching = false;
        return;
      }
      if (!this.searching) {
        this.searching = true;
        setTimeout(async () => {
          let people;
          if (!this.search || this.search.length < 3) return;
          people = await this.getPeopleByQuery(
            this.$auth.user.sub,
            this.customer.id,
            this.store.name,
            this.search,
          );
          this.matches = people;
        }, 2500);
      }
    },
  },
  async mounted() {
    await this.getSchedule();
  },
  methods: {
    async getSchedule() {
      this.$set(this, 'isLoading', true);
      this.$set(this, 'customer', await api.getCustomer(this.$auth.user.sub));
      this.$set(this, 'store', this.$store.getters.getStore);
      this.$set(this, 'situationCount', await this.getCount(
        this.$auth.user.sub,
        this.customer.id,
        this.store.name,
      ));
      this.$store.commit('SET_COUNT', this.situationCount);
      this.$set(this, 'isLoading', false);
    },
    async getPeopleByQuery(sellerId, customerId, lojaPreferida, search) {
      const res = await this.$apollo.query({
        query: FindPeople,
        variables: {
          customerId,
          sellerId,
          lojaPreferida,
          search,
        },
        fetchPolicy: 'no-cache',
      });
      this.searching = false;

      return res.data.getPeopleByQuery;
    },
    async getCount(sellerId, customerId, lojaPreferida) {
      const res = await this.$apollo.query({
        query: SituationCount,
        variables: {
          customerId,
          sellerId,
          lojaPreferida,
        },
        fetchPolicy: 'no-cache',
      });

      return res.data.getCountBySellerAndCustomerId[0];
    },
  },
};
</script>

<style scoped>
.legenda {
  font-size: 11px;
  color: grey;
  font-weight: normal;
}
.textoLead {
  color: 'primary';
}

.titulo-card {
  padding-top: 2px;
}
.customCardMenu {
  padding-top: 0px;
}
.marginToBottom {
  margin-bottom: 175px;
}
.search-autocomplete {
  font-family: 'Neue-Metana';
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 15px;
}
.menu-title {
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 16px;
}
</style>
